export default __webpack_public_path__ + "static/media/best-song-ever.f15aec45.jpg";